<template>
  <component :is="tag" data-module="CmsColumn">
    <slot :data="data" v-if="!loading"></slot>
  </component>
</template>

<script>
import {getColumn} from "~/api/CmsApi";

/**
 * 获取指定栏目信息
 * 此组件适用于页面最高层级标签，通过当前页面的栏目ID，获取到页面在的所有子栏目，并且直接通过栏目key获取栏目信息
 */
export default {
  name: 'CmsColumn',
  props: {
    /**
     * 栏目ID
     */
    id: {
      type: [String, Number],
      // 默认获取中文版栏目下子栏目
      default: '1'
    },
    /**
     * 指定元素渲染出的标签
     */
    tag: {
      type: String,
      default: 'div'
    },
    parseFunction: {
      type: Function,
      default: obj => {
        return obj;
      }
    }
  },
  data() {
    return {
      loading: true,
      data: {}
    };
  },
  watch: {
    id: {
      handler(value) {
        if (value) {
          this.initialize();
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initialize() {
      getColumn(this.id).then(res => {
        if (res.code === 0) {
          const data = res.data || {};
          this.data = this.parseFunction(data);
          this.$emit('loaded', res.data);
        } else {
          console.warn('栏目信息获取失败');
        }
        this.loading = false;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsColumn.vue